import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { apiCall } from "../utils/apiService";
import { Link, Navigate } from 'react-router-dom'


const SignInLayer = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const data = await apiCall({
                url: `user/login`,
                method: "Post",
                body: { email, password },
            });

            if (data.token) {
                localStorage.setItem("uid", data.uid);
                localStorage.setItem("token", data.token);
                localStorage.setItem("apiKey", data.apiKey);
                localStorage.setItem("instanceLimit", data.instanceLimit);
                localStorage.setItem("user", JSON.stringify(data.user));
                window.location.href = "/dashboard";
            } else {
                setError("Invalid email or password");
            }
        } catch (error) {
            setError("Invalid email or password");
            console.error("Login error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            window.location.href = "/dashboard";
        } else {
            document.title = "Sign In";
        }
    }, []);

    const imageBackground = {
        backgroundImage: `url('assets/images/whatsapp.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%'
    };

    return (
        <div className="vh-100" style={imageBackground}>
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="card shadow px-md-5 pb-md-3 px-3" style={{
                        background: '#bedfbe',
                        borderRadius: '20px'
                    }}>
                        {/* Logo */}
                        <div className="text-center mb-4">
                            <Link to="/" className="d-flex align-items-center justify-content-center text-decoration-none">
                                <img src="/assets/images/alphaxcloud.png" width={300} alt="" />
                            </Link>
                        </div>

                        {/* Header */}
                        <div className="text-center mb-4">
                            <h6 className="fw-bold">Sign In to your Account</h6>
                            <p className="text-muted small">Welcome back! please enter your detail</p>
                        </div>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3 position-relative">
                                <div className="icon-field mb-16">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="mage:email" />
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="position-relative mb-3">
                                <div className="icon-field">
                                    <span className="icon top-50 translate-middle-y">
                                        <Icon icon="solar:lock-password-outline" />
                                    </span>
                                    <input
                                        type={showPassword ? '' : 'password'}
                                        className="form-control h-56-px bg-neutral-50 radius-12"
                                        id="your-password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={isLoading}
                                    className={`toggle-password ${!showPassword ? 'ri-eye-line' : 'ri-eye-off-line'} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                    data-toggle="#your-password"
                                />
                            </div>

                            {error && (
                                <div className="alert alert-danger py-2 text-center">{error}</div>
                            )}

                            <div className="form-check mb-3 d-flex align-items-center">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="remember"
                                />
                                <label className="form-check-label" htmlFor="remember">
                                    Remember me
                                </label>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-success w-100 fw-semibold"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                ) : null}
                                {isLoading ? "Signing In..." : "Sign In"}
                            </button>

                            <div className="text-center mt-3">
                                <span className="text-muted small">Don't have an account? </span>
                                <Link to="/register" className="text-success fw-semibold small ms-4">
                                    Sign Up
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignInLayer;
